import Button from 'core-system/Button'
import { ColumnCard } from 'core-system/ColumnView'
import SummaryBudget from 'core-system/Program/Summary/SummaryBudget'
import SummaryOverview from 'core-system/Program/Summary/SummaryOverview'
import Text from 'core-system/Text'
import palette from 'core-system/Themes/palette'
import FlexSummaryOptions from 'features/Flex/Shared/components/FlexSummaryOptions'
import moment from 'moment'
import React from 'react'
import { Segment } from 'redux/employer/employerTypes'
import { FlexActiveOptions, FlexManageOptionState } from 'redux/flex/flexTypes'
import styled from 'styled-components'

const Container = styled(ColumnCard)`
  padding: 2.5rem 3.25rem;
  margin-bottom: 1rem;
`

interface FlexManageSummaryProps {
  toggleEdit: () => void
  canEdit: boolean
  program: FlexManageOptionState
  currentSegment: Segment
  activeOptions: FlexActiveOptions
  handleOpenModal: () => void
}

const FlexManageSummary = React.memo((props: FlexManageSummaryProps) => {
  const {
    toggleEdit,
    canEdit,
    program,
    currentSegment,
    activeOptions,
    handleOpenModal,
  } = props

  return (
    <Container>
      <Text variant='h4' marginBottom='1.5rem'>
        {canEdit ? "Next Month's Program" : 'Current Program'}
      </Text>
      <SummaryOverview
        startDate={moment(program.startDate, 'YYYY-MM-DD').format(
          'MMMM Do, YYYY'
        )}
        currentSegment={currentSegment}
        marginBottom='1rem'
      />
      <FlexSummaryOptions
        activeOptions={activeOptions}
        activeMerchantIds={program.flex.activeMerchantIds}
        availableMerchantIds={program.flex.availableMerchantIds}
        handleOpenModal={handleOpenModal}
        canEdit={canEdit}
      />
      <SummaryBudget
        title='Total Monthly Budget'
        metric='per commuter'
        numEmps={currentSegment.commuters}
        budget={program.budget}
        marginBottom='1.5rem'
      />
      <Text
        variant='body2'
        textColor={palette.text.placeholder}
        marginBottom={!canEdit && '1.5rem'}
      >
        All budget amounts are estimated based on max commuter spend.
      </Text>
      {!canEdit && (
        <Button width='100%' onClick={toggleEdit}>
          Edit Next Month&apos;s Program
        </Button>
      )}
    </Container>
  )
})

// Helps to identify component in React error logs
if (process.env.NODE_ENV !== 'production') {
  FlexManageSummary.displayName = 'FlexManageSummary'
}

export default FlexManageSummary
